import React from 'react';

import { getMonthNameByNumber } from 'utilities/date';

// Date is removed from Pixlee modal so this functions is not in use
// Pixlee is working on adding differnet dates in response then we can use this function to format date
const dateMillisToDateString = (dateInMillis) => {

	const date = new Date(dateInMillis);
	const day = date.getDate();
	const month = date.getMonth();
	const year = date.getFullYear();

	return `${getMonthNameByNumber(month).slice(0, 3)} ${day}, ${year}`;

};

const decodeProductName = (html) => {

	const txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;

};

const decodeDescription = (title) => {

	if (!title) {

		return '';

	}

	try {

		return window.decodeURIComponent(title);

	} catch (error) {

		console.error(`Pixlee error caught for visibility in reporting this content issue to Pixlee: ${error}`);

		// there's a known invalid %0A sequence in the content from Pixlee
		// that can cause runtime error in decodeURIComponent
		const inputTitle = title.replace(/%OA/g, '%0A');

		// no try/catch since unescape doesn't throw exception even if there are more invalid %XX sequences
		return window.unescape(inputTitle);

	}

};

const getRoomPageType = (albumDetails, shopByRoomIds, shopByRoomItemsLimit) => {

	const currentPage = window.location.href.split('/')[4];
	let albumId = null;
	let inspirationName = null;

	if (currentPage === 'room_living-room!great-room') {

		albumId = shopByRoomIds.livingRoom;
		inspirationName = '-Living-Room';

	} else if (currentPage === 'room_dining-room') {

		albumId = shopByRoomIds.diningRoom;
		inspirationName = '-Dining-Room';

	} else if (currentPage === 'room_kitchen') {

		albumId = shopByRoomIds.kitchen;
		inspirationName = '-Kitchen';

	} else if (currentPage === 'room_bathroom') {

		albumId = shopByRoomIds.bathroom;
		inspirationName = '-Bathroom';

	} else if (currentPage === 'room_bedroom') {

		albumId = shopByRoomIds.bedroom;
		inspirationName = '-Bedroom';

	} else if (currentPage === 'room_office') {

		albumId = shopByRoomIds.office;
		inspirationName = '-Office';

	} else if (currentPage === 'room_entryway') {

		albumId = shopByRoomIds.entryway;
		inspirationName = '-Entryway';

	} else if (currentPage === 'room_outdoor-living') {

		albumId = shopByRoomIds.outdoor;
		inspirationName = '-Outdoor';

	} else if (currentPage === 'room_small-space-living') {

		albumId = shopByRoomIds.smallSpace;
		inspirationName = '-Small-Space';

	}

	return {
		...albumDetails,
		albumId,
		perPage: shopByRoomItemsLimit,
		inspirationName
	};

};

const setThumbnailSize = (URL, width = 80, height = 80) => {

	const size = {
		'wid=1000': `wid=${width}`,
		'hei=1000': `hei=${height}`
	};
	return URL.replace(/wid=1000|hei=1000/g, (c) => size[c]);

};

const getSource = (source, email = '') => {

	if (source && source.includes('instagram')) {

		return 'Instagram';

	}
	if (
		(source && [ 'turnto', 'desktop' ].indexOf(source.toLowerCase()))
		|| (email && email.toLowerCase().includes('turnto'))
	) {

		return 'via Product Review';

	}

	return source;

};

const isInstagramSource = (source) => source && source.includes('instagram');
const isTurntoSource = (source, email = '') => (source && [ 'turnto', 'desktop' ].indexOf(source.toLowerCase()))
	|| (email && email.toLowerCase().includes('turnto'));

const getThumbnailImage = (item) => {

	if (item.content_type === 'image') {

		return item.pixlee_cdn_photos.square_medium_url;

	}
	const videoConfig = item.video_settings;
	return videoConfig.thumbnail_url ? videoConfig.thumbnail_url : item.thumbnail_url;

};

export {
	dateMillisToDateString,
	decodeProductName,
	decodeDescription,
	getRoomPageType,
	setThumbnailSize,
	getSource,
	getThumbnailImage,
	isInstagramSource,
	isTurntoSource
};
